// Sub-page content for Kitxens clone
const wix = (file, w = 1200, h = 900) =>
  `https://static.wixstatic.com/media/${file}/v1/fill/w_${w},h_${h},al_c,q_85,enc_avif,quality_auto/file.png`;

export const subPages = {
  services: {
    slug: 'services',
    eyebrow: 'RESTAURANT POS, IT & TECHNOLOGY SERVICES',
    image: wix('c99602_eeb6960856b14a27ba71236b20295e62~mv2.png', 1200, 900),
    bottomImage: wix('5d80b6_59d86fdc6450458695ea575c59f08b7c~mv2.jpg', 1200, 800),
    title: 'Everything Your Restaurant Needs to Scale.',
    intro:
      'Keep your restaurant running smoothly with POS management, online ordering integrations, menu updates, IT support, automation, analytics and growth solutions designed for modern restaurant operations.',
    sub:
      'From Toast, Clover and Square support to online ordering, AI automation, customer retention and performance analytics, Kitxens helps restaurants build a reliable technology foundation for long-term growth.',
    primaryCta: { label: 'Get Free Growth Audit', href: '/#audit' },
    secondaryCta: { label: 'Explore Services', href: '#systems' },
    image: 'https://images.unsplash.com/photo-1556745753-b2904692b3cd?auto=format&fit=crop&w=1200&q=70',
    pillarsTitle: 'One Partner. Five Integrated Growth Systems.',
    pillarsIntro:
      'From POS systems and AI automation to analytics, visibility, and revenue growth, Kitxens helps restaurants scale with a unified technology ecosystem.',
    pillars: [
      { icon: 'MonitorSmartphone', title: 'IT & POS Systems', text: 'Deploy, optimize and support leading restaurant technologies including POS, payments, online ordering and integrations.', href: '/it-pos-systems' },
      { icon: 'Bot', title: 'AI & Automation', text: 'Automate repetitive tasks, improve response times and leverage AI agents to increase efficiency across your operation.', href: '/ai-and-automation' },
      { icon: 'TrendingUp', title: 'Revenue Growth', text: 'Identify opportunities to increase sales, improve retention and maximize profitability through data-driven strategies.', href: '/restaurant-revenue-growth' },
      { icon: 'PieChart', title: 'Data & Analytics', text: 'Transform restaurant data into actionable insights that support smarter operational and marketing decisions.', href: '/services' },
      { icon: 'Sparkles', title: 'Digital Branding', text: 'Strengthen your online presence through websites, visibility optimization, content and customer engagement.', href: '/digital-branding' },
    ],
    benefitsTitle: "Maximizing Your Restaurant's Potential",
    benefits: [
      { icon: 'Zap', title: 'Streamlined Transactions', text: 'Reduce wait times and improve transaction efficiency, enhancing overall customer satisfaction.' },
      { icon: 'LineChart', title: 'Smarter Operations', text: 'Make data-driven decisions with unified analytics across orders, inventory and staffing.' },
      { icon: 'Megaphone', title: 'More Visibility', text: 'Get found on Google, Maps and AI search with automated local SEO and content strategy.' },
      { icon: 'Heart', title: 'Loyal Guests', text: 'Activate customer data with automated marketing that turns first-time visitors into regulars.' },
    ],
    bulletTitle: "Let\u2019s Talk About Growing Your Restaurant.",
    bullets: [
      'Restaurant Technology Systems.',
      'AI Automation for Restaurants.',
      'Local Visibility & SEO Growth.',
      'Data & Performance Analytics.',
      'Revenue Optimization Strategies.',
      'Operational Efficiency Tools.',
    ],
  },
  'it-pos-systems': {
    slug: 'it-pos-systems',
    eyebrow: 'IT & POS SYSTEMS',
    title: 'Your Cloud-Based IT & POS Department.',
    intro:
      'Keep your restaurant running smoothly with secure systems, centralized data and expert support, reducing costs, improving efficiency and giving you more time to focus on your guests.',
    sub:
      'We deploy, manage and support Toast, Clover, Square, Lightspeed and the integrations that connect them \u2014 so you have one phone, one e-mail and one team for every technical issue.',
    primaryCta: { label: 'Request Free Audit', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: 'https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&w=1400&q=80',
    bottomImage: wix('5d80b6_7e8b4a57bf794679a88d6ad3f513e5d1~mv2.jpg', 1200, 800),
    pillarsTitle: 'Built for Every Restaurant Operation.',
    pillarsIntro: 'A complete IT & POS stack, configured for your restaurant and supported 24/7.',
    pillars: [
      { icon: 'MonitorSmartphone', title: 'POS Management', text: 'Menu engineering, item updates, modifiers and 86\u2019d items kept in sync across every channel.' },
      { icon: 'CreditCard', title: 'Payments & Hardware', text: 'Card readers, KDS, printers and terminals deployed, monitored and replaced before they fail.' },
      { icon: 'Network', title: 'Online Ordering Integrations', text: 'DoorDash, Uber Eats, Grubhub and direct orders flowing into a single source of truth.' },
      { icon: 'ShieldCheck', title: 'Security & Backup', text: 'Network hardening, PCI compliance support and continuous backups for every location.' },
      { icon: 'Headphones', title: '24/7 Support Desk', text: 'A dedicated technology team on call \u2014 one phone, one e-mail, real humans.' },
    ],
    benefitsTitle: 'Why Restaurants Switch to Kitxens.',
    benefits: [
      { icon: 'Clock', title: 'Faster Resolutions', text: 'Most tickets resolved remotely in under 15 minutes, with on-site escalation when needed.' },
      { icon: 'Banknote', title: 'Lower IT Costs', text: 'Replace multiple vendors with one predictable subscription and consolidated support.' },
      { icon: 'BarChart3', title: 'Centralized Data', text: 'See sales, labor and operations across every location from a single dashboard.' },
      { icon: 'Smile', title: 'Happier Teams', text: 'When the tech just works, your team focuses on what they do best \u2014 hospitality.' },
    ],
    bulletTitle: "What's Included.",
    bullets: [
      'POS configuration, menu updates and item management.',
      'Hardware procurement, deployment and warranty handling.',
      'Online ordering and delivery integrations.',
      'Network, Wi-Fi and security monitoring.',
      'PCI and compliance support.',
      '24/7 ticket-based and phone support.',
    ],
  },
  'restaurant-revenue-growth': {
    slug: 'restaurant-revenue-growth',
    eyebrow: 'RESTAURANT REVENUE GROWTH',
    title: 'Increase Sales, Retention and Profitability.',
    intro:
      'Optimize operational efficiency with digital tools that increase online orders, improve workflows, reduce manual tasks and help restaurants retain loyal customers while maximizing profitability across every channel.',
    sub:
      'We combine pricing strategy, menu engineering, automated marketing and customer data activation to drive measurable revenue growth in 60 to 90 days.',
    primaryCta: { label: 'Get My Revenue Plan', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: 'https://images.unsplash.com/photo-1600891964599-f61ba0e24092?auto=format&fit=crop&w=1400&q=80',
    bottomImage: wix('5d80b6_30c2df264d3f4c5d97b31747f02d1694~mv2.jpg', 1200, 800),
    pillarsTitle: 'Five Levers of Restaurant Revenue.',
    pillarsIntro: 'Connected systems that compound: more orders, larger checks, repeat guests, lower costs.',
    pillars: [
      { icon: 'TrendingUp', title: 'Order Volume Growth', text: 'Increase orders across direct, delivery and dine-in channels with targeted campaigns and visibility.' },
      { icon: 'Receipt', title: 'Average Ticket Lift', text: 'Menu engineering, upsell prompts and bundles that grow check size without hurting conversion.' },
      { icon: 'Heart', title: 'Customer Retention', text: 'Automated loyalty, win-back and referral journeys that turn first-time guests into regulars.' },
      { icon: 'Banknote', title: 'Cost Optimization', text: 'Identify food cost leaks, labor inefficiencies and underperforming items with data-led insights.' },
      { icon: 'Megaphone', title: 'Channel Performance', text: 'Optimize pricing and promos by channel to protect margin while growing top-line revenue.' },
    ],
    benefitsTitle: 'Real Outcomes Restaurants See.',
    benefits: [
      { icon: 'TrendingUp', title: '+15% Avg. Ticket', text: 'Roc \u2018N\u2019 Ramen grew average check by 15%, roughly $120,000/year at full capacity.' },
      { icon: 'LineChart', title: '+24% Orders', text: 'Multi-location concepts see 20\u201330% lift in direct orders within the first 90 days.' },
      { icon: 'Users', title: '92% Retention', text: 'Activated guest databases produce industry-leading repeat visit rates.' },
      { icon: 'PieChart', title: '\u22128% Food Cost', text: 'Menu engineering and waste analytics typically reduce food cost by 5\u20138%.' },
    ],
    bulletTitle: 'How We Drive Revenue.',
    bullets: [
      'Restaurant revenue audit and opportunity sizing.',
      'Menu engineering and pricing strategy.',
      'Automated email, SMS and loyalty campaigns.',
      'Direct ordering optimization to reduce third-party fees.',
      'Channel mix and promo performance analytics.',
      'Weekly reporting with a dedicated growth lead.',
    ],
  },
  'digital-branding': {
    slug: 'digital-branding',
    eyebrow: 'DIGITAL BRANDING & VISIBILITY',
    title: 'Be Discovered. Be Chosen. Be Remembered.',
    intro:
      "Strengthen your restaurant's digital footprint through websites, visibility optimization, content, social and customer engagement that attract more guests and increase repeat business.",
    sub:
      'From your Google Business Profile and website to social content and reputation management, we build a digital brand that converts searches into seated guests.',
    primaryCta: { label: 'Boost My Visibility', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80',
    bottomImage: wix('c99602_7cefff9b9c5e4148a68c2e38b5f4f27c~mv2.png', 1400, 600),
    pillarsTitle: 'A Complete Digital Brand System.',
    pillarsIntro: 'Everything guests see before they walk in \u2014 designed, optimized and managed for you.',
    pillars: [
      { icon: 'Globe', title: 'Restaurant Websites', text: 'High-converting websites with online ordering, reservations and menu sync.' },
      { icon: 'Search', title: 'Local SEO & GBP', text: 'Google Business Profile optimization, citations and review velocity to rank locally.' },
      { icon: 'Camera', title: 'Content & Photography', text: 'Food photography, social content calendars and short-form video produced monthly.' },
      { icon: 'Star', title: 'Reputation Management', text: 'Automated review requests, response workflows and sentiment monitoring.' },
      { icon: 'Megaphone', title: 'Paid & Social Ads', text: 'Meta and Google campaigns tuned to drive measurable orders, not just impressions.' },
    ],
    benefitsTitle: 'Why Restaurants Choose Kitxens for Branding.',
    benefits: [
      { icon: 'Eye', title: 'More Discoverability', text: 'Show up in Google Maps, AI search and social where guests are actually looking.' },
      { icon: 'Heart', title: 'Stronger Brand', text: 'Consistent visuals, voice and messaging across every channel and location.' },
      { icon: 'Star', title: 'Better Reviews', text: 'Higher star ratings and more reviews driven by automated post-visit journeys.' },
      { icon: 'TrendingUp', title: 'Direct Orders Up', text: 'Convert search and social traffic into commission-free direct orders.' },
    ],
    bulletTitle: "What's Included.",
    bullets: [
      'Custom restaurant website with online ordering.',
      'Google Business Profile and local SEO optimization.',
      'Monthly content, photography and social posting.',
      'Reputation management and review automation.',
      'Paid social and Google ad campaigns.',
      'Brand identity, menu design and print collateral.',
    ],
  },
  'ai-and-automation': {
    slug: 'ai-and-automation',
    eyebrow: 'AI & AUTOMATION',
    title: 'AI Agents and Workflows Built for Restaurants.',
    intro:
      'Automate repetitive tasks, improve response times and leverage AI agents to increase efficiency across reservations, ordering, marketing and back-office operations.',
    sub:
      'Index AI connects your guest data, POS, ordering and marketing channels into intelligent workflows that work 24/7 \u2014 so your team can focus on hospitality.',
    primaryCta: { label: 'Automate My Restaurant', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: '/images/ai-automation-hero.jpg',
    bottomImage: '/images/ai-automation-wide.jpg',
    pillarsTitle: 'AI Agents Across the Restaurant.',
    pillarsIntro: 'Five specialized agents that connect to your existing stack and start delivering value on day one.',
    pillars: [
      { icon: 'Phone', title: 'AI Reception Agent', text: 'Answer calls, take reservations, handle FAQs and capture missed-call orders 24/7.' },
      { icon: 'MessageSquare', title: 'Review Responder', text: 'Reply to every Google, Yelp and TripAdvisor review in your brand voice within minutes.' },
      { icon: 'Mail', title: 'Marketing Agent', text: 'Plan, write and schedule email and SMS campaigns based on real guest behavior.' },
      { icon: 'Bot', title: 'Ordering Assistant', text: 'On-site chat and voice ordering that recommends, upsells and routes to your POS.' },
      { icon: 'BarChart3', title: 'Insights Agent', text: 'Daily summaries, anomaly alerts and growth recommendations delivered to your phone.' },
    ],
    benefitsTitle: 'What Automation Unlocks.',
    benefits: [
      { icon: 'Clock', title: 'Hours Back Each Week', text: 'Owners save 10\u201315 hours per week on repetitive admin and communication tasks.' },
      { icon: 'Phone', title: 'Zero Missed Calls', text: 'Every inbound call is answered, qualified and converted into a reservation or order.' },
      { icon: 'Star', title: 'Faster Reputation', text: 'Review response times drop from days to minutes, boosting star ratings and trust.' },
      { icon: 'TrendingUp', title: 'More Revenue', text: 'Smart upsells, win-back flows and recommendations measurably grow average check.' },
    ],
    bulletTitle: 'How We Roll Out AI.',
    bullets: [
      '30-minute discovery call and automation audit.',
      'Agent configuration tuned to your brand voice and menu.',
      'POS, ordering, CRM and review platform integrations.',
      'Live launch with monitoring and weekly tuning.',
      'Monthly performance reports and optimization.',
      'Dedicated automation lead and 24/7 support.',
    ],
  },
  'ai-agents-for-restaurants': {
    slug: 'ai-agents-for-restaurants',
    eyebrow: 'AI AGENTS FOR RESTAURANTS',
    title: 'A Team of AI Agents Working 24/7.',
    intro:
      'Specialized AI agents that answer calls, take orders, respond to reviews, send marketing campaigns and surface insights \u2014 trained on your brand voice and connected to your existing stack.',
    sub:
      'Each agent is configured for your concept, integrated with your POS and ordering platforms, and supervised by a real Kitxens team. You stay in control while your operation runs on autopilot.',
    primaryCta: { label: 'Deploy My AI Team', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: wix('c99602_ac7f083ed96a4f9da47325c01b9fa98b~mv2.png', 1400, 600),
    bottomImage: wix('c99602_4f0eba93dae948b682c0dfa24a6bf40d~mv2.png', 1200, 800),
    pillarsTitle: 'Meet Your Restaurant\u2019s AI Workforce.',
    pillarsIntro: 'Plug-and-play agents that start delivering measurable value within the first week.',
    pillars: [
      { icon: 'Phone', title: 'Reception Agent', text: 'Answers every call, books reservations, handles FAQs and captures missed-call orders 24/7.' },
      { icon: 'MessageSquare', title: 'Reviews Agent', text: 'Replies to Google, Yelp and TripAdvisor reviews in your brand voice within minutes.' },
      { icon: 'Mail', title: 'Marketing Agent', text: 'Writes, schedules and personalizes email and SMS campaigns based on real guest behavior.' },
      { icon: 'Bot', title: 'Ordering Agent', text: 'On-site chat and voice ordering that recommends, upsells and routes orders to your POS.' },
      { icon: 'Users', title: 'Concierge Agent', text: 'Handles loyalty enrollment, gift cards, group bookings and post-visit follow-ups.' },
      { icon: 'BarChart3', title: 'Insights Agent', text: 'Daily summaries, anomaly alerts and growth recommendations delivered to your phone.' },
    ],
    benefitsTitle: 'What an AI Team Unlocks.',
    benefits: [
      { icon: 'Clock', title: '10\u201315 Hours / Week Saved', text: 'Owners reclaim time previously spent on repetitive admin and communications.' },
      { icon: 'Phone', title: 'Zero Missed Calls', text: 'Every inbound conversation is answered, qualified and converted.' },
      { icon: 'Star', title: 'Faster Reputation', text: 'Review response time drops from days to minutes, boosting ratings and trust.' },
      { icon: 'TrendingUp', title: '+12\u201320% Revenue', text: 'Smart upsells, win-back flows and recommendations grow average check measurably.' },
    ],
    bulletTitle: 'How We Roll Out Your AI Team.',
    bullets: [
      'Discovery call and use-case mapping.',
      'Agent training on your menu, FAQs and brand voice.',
      'POS, ordering, CRM and review platform integrations.',
      'Soft launch with human-in-the-loop supervision.',
      'Weekly performance tuning and reporting.',
      'Dedicated automation lead and 24/7 support.',
    ],
  },
  'index-ai': {
    slug: 'index-ai',
    eyebrow: 'INDEX AI',
    title: 'Be Indexed Everywhere Guests Search.',
    intro:
      'Index AI is our restaurant visibility engine. It optimizes how your brand shows up across Google, Maps, AI search and social discovery \u2014 so more guests find you, choose you and come back.',
    sub:
      'We combine local SEO, structured data, AI search optimization and review velocity into one continuous program designed to put your restaurant at the top of every relevant search.',
    primaryCta: { label: 'Index My Restaurant', href: '/#audit' },
    secondaryCta: { label: 'Explore All Services', href: '/services' },
    image: wix('c99602_6065da149e8648a2b04f3d0d7eec44a4~mv2.png', 1400, 600),
    bottomImage: wix('c99602_230d590909ad497cbfeddbcfa338e18f~mv2.png', 1200, 800),
    pillarsTitle: 'How Index AI Makes You Discoverable.',
    pillarsIntro: 'A continuous loop of optimization, content and signals that compounds month over month.',
    pillars: [
      { icon: 'Search', title: 'Local SEO', text: 'Citations, schema markup and on-page optimization that lift you in Google\u2019s local pack.' },
      { icon: 'MapPin', title: 'Google Business Profile', text: 'Hours, photos, menus and posts kept fresh \u2014 the #1 driver of local discovery.' },
      { icon: 'Sparkles', title: 'AI Search Optimization', text: 'Structured answers and content tuned for ChatGPT, Perplexity and Google AI Overviews.' },
      { icon: 'Star', title: 'Review Velocity', text: 'Automated post-visit review requests that grow ratings and trust signals over time.' },
      { icon: 'Share2', title: 'Social Discovery', text: 'Short-form video, geo-tagging and creator collaborations that drive new guest traffic.' },
      { icon: 'Globe', title: 'Directory Sync', text: 'Yelp, TripAdvisor, OpenTable, Apple Maps and 40+ directories synced and monitored.' },
    ],
    benefitsTitle: 'The Index AI Outcome.',
    benefits: [
      { icon: 'Eye', title: 'More Impressions', text: 'Typically 2\u20133x growth in Google Business Profile views within 90 days.' },
      { icon: 'MousePointerClick', title: 'More Actions', text: 'Calls, direction requests and website visits grow alongside impressions.' },
      { icon: 'Star', title: 'Higher Ratings', text: 'Average star rating climbs as review volume and response time improve.' },
      { icon: 'TrendingUp', title: 'More Revenue', text: 'Direct orders and reservations grow as discovery and trust compound.' },
    ],
    bulletTitle: 'What\u2019s Inside Index AI.',
    bullets: [
      'Full local SEO audit and optimization.',
      'Google Business Profile management.',
      'AI search content and schema strategy.',
      'Review automation and reputation monitoring.',
      'Directory listing sync across 40+ platforms.',
      'Monthly visibility reporting and growth playbook.',
    ],
  },
};
